import React, { useState, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { FormGroup, FormLabel } from "react-bootstrap";
import { getAuthorUniversityList } from "../../../services/authorService";

const UniversitySelector = ({ author, setAuthor, token }) => {
  const [universities, setUniversities] = useState([]);
  const [selectedUniversity, setSelectedUniversity] = useState(null);
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [faculties, setFaculties] = useState([]);
  const [departments, setDepartments] = useState([]);

  // Üniversite listesini getir
  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const response = await getAuthorUniversityList(token);
        setUniversities(response.data || []);
      } catch (error) {
        console.error("Üniversite verileri çekilemedi:", error);
        setUniversities([]);
      }
    };

    fetchUniversities();
  }, [token]);

  // Varsayılan üniversiteyi ayarla
  useEffect(() => {
    if (author.institution && universities.length > 0) {
      const universityOption = universities.find(uni => uni.name === author.institution);
      if (universityOption) {
        setSelectedUniversity({ value: universityOption.name, label: universityOption.name });
        setFaculties(universityOption.facultiesanddepartments || []);
      }
    }
  }, [universities, author.institution]);

  // Varsayılan fakülteyi ayarla
  useEffect(() => {
    if (author.faculty && faculties.length > 0) {
      const facultyOption = faculties.find(fac => fac.faculty === author.faculty);
      if (facultyOption) {
        setSelectedFaculty({ value: facultyOption.faculty, label: facultyOption.faculty });
        setDepartments(facultyOption.departments || []);
      }
    }
  }, [faculties, author.faculty]);

  // Varsayılan bölümü ayarla
  useEffect(() => {
    if (author.department && departments.length > 0) {
      const departmentOption = departments.find(dep => dep === author.department);
      if (departmentOption) {
        setSelectedDepartment({ value: departmentOption, label: departmentOption });
      }
    }
  }, [departments, author.department]);

  return (
    <div>
      {/* Üniversite Seçimi */}
      <FormGroup>
        <FormLabel for="university">Üniversite</FormLabel>
        <CreatableSelect
          id="university"
          value={selectedUniversity}
          onChange={(option) => {
            setSelectedUniversity(option);
            setSelectedFaculty(null);
            setSelectedDepartment(null);
            setDepartments([]);
            setAuthor({ ...author, institution: option.value, faculty: "", department: "" });

            const university = universities.find(uni => uni.name === option.value);
            setFaculties(university ? university.facultiesanddepartments : []);
          }}
          onCreateOption={(inputValue) => {
            const newOption = { value: inputValue, label: inputValue };
            setUniversities([...universities, { name: inputValue, facultiesanddepartments: [] }]);
            setSelectedUniversity(newOption);
            setAuthor({ ...author, institution: inputValue, faculty: "", department: "" });
          }}
          options={universities.map(uni => ({ value: uni.name, label: uni.name }))}
          placeholder="Üniversite Seçiniz"
          isSearchable
        />
      </FormGroup>

      {/* Fakülte Seçimi */}
      <FormGroup>
        <FormLabel for="faculty">Fakülte</FormLabel>
        <CreatableSelect
          id="faculty"
          value={selectedFaculty}
          onChange={(option) => {
            setSelectedFaculty(option);
            setSelectedDepartment(null);
            setAuthor({ ...author, faculty: option.value, department: "" });

            const faculty = faculties.find(fac => fac.faculty === option.value);
            setDepartments(faculty ? faculty.departments : []);
          }}
          onCreateOption={(inputValue) => {
            const newOption = { value: inputValue, label: inputValue };
            setFaculties([...faculties, { faculty: inputValue, departments: [] }]);
            setSelectedFaculty(newOption);
            setAuthor({ ...author, faculty: inputValue, department: "" });
          }}
          options={faculties.map(fac => ({ value: fac.faculty, label: fac.faculty }))}
          placeholder="Fakülte Seçiniz"
          isSearchable
          isDisabled={!selectedUniversity}
        />
      </FormGroup>

      {/* Bölüm Seçimi */}
      <FormGroup>
        <FormLabel for="department">Bölüm</FormLabel>
        <CreatableSelect
          id="department"
          value={selectedDepartment}
          onChange={(option) => {
            setSelectedDepartment(option);
            setAuthor({ ...author, department: option.value });
          }}
          onCreateOption={(inputValue) => {
            const newOption = { value: inputValue, label: inputValue };
            setDepartments([...departments, inputValue]);
            setSelectedDepartment(newOption);
            setAuthor({ ...author, department: inputValue });
          }}
          options={departments.map(dep => ({ value: dep, label: dep }))}
          placeholder="Bölüm Seçiniz"
          isSearchable
          isDisabled={!selectedFaculty}
        />
      </FormGroup>
    </div>
  );
};

export default UniversitySelector;
